<template>
  <footer>
    <ContainerGrid>
      <div class="relative col-span-3 flex h-2xl items-center justify-center">
        <div class="absolute left-none flex flex-row items-center gap-lg type-body-sm">
          Release: {{ version }}
          <nav aria-label="InternalNavigation">
            <RouterLink to="/releaser/" target="_blank"
              >Releaseinformation</RouterLink
            >&nbsp;
          </nav>
        </div>
        <img class="h-lg" src="@/assets/avtalat-logo.svg" alt="Avtalat" />
      </div>
    </ContainerGrid>
  </footer>
</template>

<script setup lang="ts">
import { ContainerGrid } from "@/layout";
import version from "@/config/version";
</script>
